module.exports = "<ng-progress [color]=\"'#e05200'\"></ng-progress>\n<router-outlet></router-outlet>"